import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useLanguage } from '@/hooks/useLanguage';
import { setLanguageFromPath } from '@/config/i18n';
import type { SupportedLanguage } from '@/lib/languageUtils';
import { LANG_PREFIXES } from './LangWrapper';

const LANG_SET = new Set<string>(LANG_PREFIXES);

/**
 * Protected/app routes (dashboard, cctv-design, auth, …) are unprefixed by design —
 * language lives in useLanguage(), not the URL. If a user lands on /id/dashboard,
 * set the language and redirect to the canonical /dashboard so the hook/i18n take over.
 */
export default function LangRedirect({ to }: { to: string }) {
  const { lang } = useParams<{ lang: string }>();
  const { changeLanguage } = useLanguage();

  if (lang && LANG_SET.has(lang)) {
    setLanguageFromPath(`/${lang}`);
  }

  useEffect(() => {
    if (lang && LANG_SET.has(lang)) {
      changeLanguage(lang as SupportedLanguage);
    }
  }, [lang, changeLanguage]);

  return <Navigate to={to} replace />;
}
